// extracted by mini-css-extract-plugin
export var cardHeader = "_eu-0";
export var reorderHandle = "_eu-3";
export var titleArea = "_eu-1";
export var titleAreaWithHandle = "_eu-2";